<template>
  <div>
    <vxe-card>
      <div slot="title">
        <vxe-button content="tab.locationLimit" mode="text" status="primary"/>
      </div>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(item)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable: true}"
        :data="list"
        :export-config="{}"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        keep-source
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="150"/>
        <vxe-column field="item.name" title="business.label.itemName" width="300"/>
        <vxe-column field="ordinal" title="business.label.ordinal" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:limitTypes}" field="limitType" title="business.label.limitType" width="100"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="200"/>
        <vxe-column field="region.no" title="business.label.region" width="200"/>
        <vxe-column field="location.no" title="business.label.location" width="200"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="receivable" title="business.label.receivable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="shippable" title="business.label.shippable" width="70"/>
        <vxe-column field="caseThreshold" title="business.label.caseThreshold" width="100"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="copy(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <location-limit-editor ref="editor" :limit-types="limitTypes" @success="refresh(item)"/>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import { Item } from '@/api/dto/common/Item'
import LocationLimitEditor from '@/views/basedata/item/LocationLimitEditor.vue'

export default {
  name: 'LocationLimitTable',
  components: { LocationLimitEditor },
  data() {
    return {
      loading: false,
      item: new Item(),
      list: []
    }
  },
  props: {
    limitTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    refresh(item) {
      this.item = item
      if (this.item.isNew()) {
        return this.$message.warning('请先选择商品')
      }
      this.loading = true
      findAll('locationLimitFactory', { 'item.id': this.item.id }).then(res => {
        if (res.success) {
          this.list = res.result
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.$refs.editor.add(this.item)
    },
    edit(row) {
      this.$refs.editor.edit(row.id, false)
    },
    copy(row) {
      this.$refs.editor.edit(row.id, true)
    }
  }
}
</script>